import { DICT_KEY, getDictNameByCode, getModel, setModel } from "../../../utils/constants";
import ModelUtils from "../../../utils/ModelUtils";
import partOrCustomerService from "./partOrCustomerService";
const partOrCustomerModel = {
    state:{
        searchParam:{},//查询参数
        partOrCustomerList:[],//按配件或客户查询销售情况
        searchPage:{  //配件交易频次分页
            total: 0,
            pageNum: 1,
            pageSize: 15
        },
        partOrCustomerStatistics:{} //总计
    },
    reducers:{
        setSearchParam(state, payload){
            state.searchParam = {...state.searchParam,...payload}
        },
        setPartOrCustomerList(state, payload){
            state.partOrCustomerList = payload
        },
        setSearchPage(state, payload){
            state.searchPage = payload
        },
        setPartOrCustomerStatistics(state,payload){
            state.partOrCustomerStatistics = {...state.partOrCustomerStatistics,...payload}
        },
        resetSearchParam(state){
            state.searchParam = {}
        }
    },
    effects: () => ({
        //加载配件或客户查询销售列表
        async loadListDetail({showMsg = true, duration = 5, data}){
            const funName = "加载配件或客户列表数据";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async ()=>{
                let retData = await partOrCustomerService.findPage(data);
                const {list,statistics, ...page} = retData;
                // console.log(list,statistics)
                const mappedList = list.map(el=>{
                    return {
                        key: el.id,
                        ...el,
                        categoryName:el.category?getDictNameByCode(DICT_KEY.CM_DICT.MATERIAL_SORT, el.category, true) : "",
                    }
                })
                this.setPartOrCustomerList(mappedList)
                this.setSearchPage(page)
                this.setPartOrCustomerStatistics(statistics)
            }
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);            
        },
        //导出配件或客户查询销售列表
        async exportPartDealList({ showMsg = true, duration = 5, data }) {
            const funName = "配件或客户销售数据";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // console.log("导出成功")
            const func = async () => {
                let retData = await partOrCustomerService.export(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },        
    })
}
export default partOrCustomerModel